module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("free_gallery_photolist_item", [["div",{"data-id":"","id":"photo-&&1&&","class":"photo-item animated"},[["img",{"src":"","alt":"fhg - &&1&&- &&2&&"},[],[["url","src",true],["resource","alt"],["screenName","alt",false,[],"env"]]]],[["resource","data-id",true],["resource","id"]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/sitepage/freeHostedGalleryTemplates.tpl
// module id = 759
// module chunks = 4